<template>
    <p v-show="alerte.length" :key="idAlerte" class="popup-message" :style="[alerte[0] == 0 ? {'background-color': '#e74c3c'} : {'background-color': '#26a65b'}]">{{ alerte[1] }}</p>
    
    <div class="login-background"></div>

    <div class="login-form">
        <img src="/games/static/clicktestcps-games-logofr-admin.png" alt="Administration" draggable="false">
        
        <form action="" method="POST" @submit.prevent="validation">
            <input type="text" placeholder="Identifiant" :value="identifiant" @input="identifiant= $event.target.value" />
            <input type="password" placeholder="Mot de passe" :value="mdp" @input="mdp= $event.target.value" />

            <input type="text" placeholder="Autre (laisser vide)" :value="autre" @input="autre= $event.target.value" class="autre" autocomplete="false" />

            <input type="submit" value="Connexion" />
        </form>
    </div>
</template>

<script>
    export default {
        name: "AdminConnection",
        data() {
            return {
                identifiant: '',
                mdp: '',
                autre: '',
                
                erreur: '',

                idAlerte: 0,
                alerte: [],

                formData: null,
                
                metas: {
                    title: 'Administration - Games™ par ClickTestCPS',
                    meta: [
                        { name: 'robots', content: 'none' }
                    ]
                }
            }
        },
        mounted() {
            useHead(this.metas);
            this.checkSession();
        },
        methods: {
            checkSession() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1"
                }));

                axios
                .post(this.$store.state.apiUrl+"?request=checkSession", formData, { withCredentials: true })
                .then((response) => {
                    if(response.data == 'admin') {
                        this.$router.replace({ name: 'adminPanel' });
                    }
                });
            },
            formCompleted() {
                let valide = false;

                if (this.identifiant && this.identifiant.trim() && this.mdp && this.mdp.trim() && !this.autre) {
                    valide = true;
                }
                return valide;
            },
            validation() {
                if (this.formCompleted()) {
                    this.loginAccount();
                } else {
                    this.alerte = ['0', 'Les champs doivent être renseignés.'];
                    this.idAlerte++;
                }
            },
            loginAccount() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    login: this.identifiant,
                    password: this.mdp
                }));

                axios
                .post(this.$store.state.apiUrl+"?request=loginAccount", formData, { withCredentials: true })
                .then((response) => {
                    if(response.data.id) {
                        this.$router.replace({ name: 'adminPanel' });
                    }
                    else {
                        this.alerte = ['0', 'Les identifiants sont incorrects.'];
                        this.idAlerte++;
                    }
                });
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
